import comboComponent from "@/components/child/form/combo.vue";
import dateTimePickerComponent from "@/components/child/form/datetimepicker.vue";
import infoBagdeComponent from "@/components/child/infoBagde/infoBagde.vue";
import searchComboComponent from "@/components/child/searchCombo/search.vue";
import { Component } from "@/decorators";
import ColetaModel from "@/models/expedicao/coletaModel";
import ColetaService from "@/services/expedicao/coletaService";
import localEntregaService from "@/services/transporte/localEntregaService";
import { getClienteCombo } from "@/utils/common/combo/combotext";
import { editDateWithTime } from "@/utils/common/date";

import EditComponentBase from "../editComponentBase";

@Component({
    components: {
        dateTimePickerComponent,
        comboComponent,
        searchComboComponent,
        infoBagdeComponent,
    },
    computed: {
        infoBagdeText() {
            return this.model.vendedorNome
                ? "Data criação: " +
                      editDateWithTime(this.model.dataCriacao) +
                      " - Vendedor: " +
                      this.model?.vendedorNome
                : "Data criação: " + editDateWithTime(this.model.dataCriacao);
        },
    },
})
export default class ColetaEditComponent extends EditComponentBase<ColetaModel> {
    infoBagdeText: string;

    locaisEntregaOptions: Array<Object> = [];

    private customComboTextCliente = getClienteCombo;

    private async beforeMount() {
        await this.setProps(new ColetaService(), "coleta", new ColetaModel());
        this.locaisEntregaOptions = await localEntregaService.comboCached(this.usuarioLogado.franquiaId);
    }
}
